module.exports = __webpack_public_path__ + "static/media/desktop.3830763b.ini";


//////////////////
// WEBPACK FOOTER
// ./src/img/desktop.ini
// module id = 1129
// module chunks = 0 1